import React, { useEffect, useState } from 'react';
import { BackButton, LoginButton, LogOutButton } from '@components';
import { useStore } from '@hooks';
import { AuthLayout } from '@layouts';
import { Loader } from '@ui';
import { Flex } from 'antd';
import { observer } from 'mobx-react';
import CreateAccount from './components/CreateAccount';
import CreateUser from './components/CreateUser';
import { StepsStyled } from './styled';
import { getSteps } from './utils';

const Register = observer(() => {
    const store = useStore();
    const { hasAccount, whoAmI, me, hasInviteDeveloper } = store.authStore;
    const steps = getSteps(store);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            if (me === undefined) {
                await whoAmI();
            }
            setLoading(false);
        })();
    }, []);

    return (
        <React.Fragment>
            {loading && <Loader size='120px' />}
            <AuthLayout
                leftCol={me ? <LogOutButton /> : <BackButton />}
                title={hasInviteDeveloper || !hasAccount ? 'Let’s create your account' : 'Add new store'}
                rightCol={me ? null : <LoginButton />}
            >
                {!loading && (
                    <Flex vertical gap={48}>
                        {!hasAccount && !hasInviteDeveloper && (
                            <StepsStyled $isColoredTail={!!me} labelPlacement='vertical' current={2} items={steps} />
                        )}

                        {me ? <CreateAccount /> : <CreateUser />}
                    </Flex>
                )}
            </AuthLayout>
        </React.Fragment>
    );
});

export default Register;
